import { Component, Input, ViewChild, AfterViewInit, Output, forwardRef, OnInit, ViewEncapsulation } from '@angular/core';
import { EventEmitter } from 'events';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

declare var $: any;

@Component({
    selector: 'app-summernote',
    templateUrl: './summernote.component.html',
    styleUrls: ['./summernote.component.scss'],
    encapsulation: ViewEncapsulation.None,

    providers: [
        {
          provide: NG_VALUE_ACCESSOR,
          multi: true,
          useExisting: forwardRef(() => AppSummernoteComponent),
        }
    ]
})
export class AppSummernoteComponent implements OnInit, AfterViewInit, ControlValueAccessor {

    public htmlChange = new EventEmitter();

    public onTouchedCallback: () => void = () => {};
    public onChangeCallback: (_: any) => void = () => {};

    _html: string;
    set html(value: string) {
        this._html = value;
        $('#summernote').summernote('code', this._html);
        this.onChangeCallback(this._html);
    }

    get html() {
        return this._html;
    }

    disabled = false;

    constructor() {
    }
    ngOnInit() {
        $('#summernote').summernote({
            airMode: false,
            lang: "fr-FR",
            toolbar: [
                // [groupName, [list of button]]
                ['style', ['style']],
                ['font', ['bold', 'underline', 'clear']], // , 'strikethrough'
                ['fontname', ['fontname']],
                ['fontsize', ['fontsize']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                // ['height', ['height']],
                ['table', ['table']],
                ['insert', ['link', 'hr', 'picture']],
                ['view', ['codeview', 'help', 'undo', 'redo']],
            ],
            fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier', 'Courier New', 'Helvetica', 'Times', 'Verdana'],
            fontSizes: ['8', '9', '10', '11', '12', '14', '18', '24', '36', '48', '72'],
            placeholder: 'Corps du message',
          });
    }
    ngAfterViewInit() {
        //$('#summernote').summernote();

        $('#summernote').on('summernote.change', (we, contents, editable) => {
            this._html = contents;
            this.onChangeCallback(this._html);
        });
        // $('#summernote').summernote('pasteHTML', this._html);
    }

    writeValue(value: any): void {
        this._html = value;
        $('#summernote').summernote('code', this._html);
    }
    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }


}


// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/summernote/summernote.component.ts